import '../../scss/parts/correlation.scss';
import Chart from 'chart.js/auto';

(function ($) {
    $(async function () {
        window.$ = jQuery;
        const matrix = {};
        const chart1Datasets = {};
        const chart2Datasets = {};
        let chart1, chart2, pair = ['bitcoin', 'ethereum'];
        let currentPeriod = '1M';
        let chartData1 = null;
        let chartData2 = null;

        const formatSmallNumber = (value) => {
            if (value >= 0.01 || value === 0) {
                return Math.round(value * 1000) / 1000;
                // return value.toString(); // Не форматируем обычные числа
            }


            const parts = value.toExponential(20).split('e-'); // высокая точность
            let significant = parts[0].replace('.', ''); // Убираем точку
            const zeroCount = parseInt(parts[1]) - 1;

            // Обрезаем до 10 цифр, удаляем завершающие нули
            significant = significant.replace(/0+$/, '');

            return `0.0(${zeroCount})${significant}`.slice(0, 10);
        };

        const getColorByCorrelation = function (correlation) {
            if (correlation === 1) return '#71122F';
            else if (correlation >= 0.9) return '#95142E';
            else if (correlation >= 0.8) return '#BC2830';
            else if (correlation >= 0.7) return '#D24536';
            else if (correlation >= 0.6) return '#DE7743';
            else if (correlation >= 0.5) return '#E59E51';
            else if (correlation >= 0.4) return '#EBC368';
            else if (correlation >= 0.3) return '#F3E087';
            else if (correlation >= 0.2) return '#F9F4AF';
            else if (correlation >= 0.1) return '#FEFFDC';
            else return '#FEFFEF';
        }

        function getFontColorByCorrelation(correlation)
        {
            if (correlation >= 0.6) return '#FFFFFF';
            else return '#292B2D';
        }


        const fillMatrix = function () {
            for (let coinId in matrix[currentPeriod]) {
                for (let coinId2 in matrix[currentPeriod][coinId]) {
                    const el = $('[data-coin1="' + coinId + '"][data-coin2="' + coinId2 + '"]');
                    el.text(Math.round(matrix[currentPeriod][coinId][coinId2] * 100) / 100);
                    el.css('background', getColorByCorrelation(matrix[currentPeriod][coinId][coinId2]));
                    el.css('color', getFontColorByCorrelation(matrix[currentPeriod][coinId][coinId2]));
                }
            }
        };

        const fetchMatrix = function (period, coin1, coin2) {
            $.post(ajaxurl, {period, action: 'getDataForMatrix'}, response => {
                matrix[period] = response.data;
            });
        };

        const fetchChart1 = function (period, coin1, coin2) {
            if (chart1Datasets[period] && chart1Datasets[period][coin1 + '-' + coin2]) {
                chartData1 = chart1Datasets[period][coin1 + '-' + coin2];
                loadChart1();
            } else {
                $('.correlation-loader').addClass('open');
                $.post(ajaxurl, {coin1, coin2, period, action: 'getCorrelationChartData'}, function (response) {
                    chartData1 = response.data;

                    chart1Datasets[period] = {
                        [coin1 + '-' + coin2]: chartData1
                    };

                    loadChart1();
                }).always(() => {
                    $('.correlation-loader').removeClass('open');
                    $('.correlation-chart1-block').addClass('open');
                });
            }
        };

        const fetchChart2 = function (period, coin1, coin2) {
            if (chart2Datasets[period] && chart2Datasets[period][coin1 + '-' + coin2]) {
                chartData2 = chart2Datasets[period][coin1 + '-' + coin2];
                loadChart2();
            } else {
                $('.correlation-loader').addClass('open');
                $.post(ajaxurl, {coin1, coin2, period, action: 'getRegressionChartData'}, function (response) {
                    chartData2 = response.data;

                    chart2Datasets[period] = {
                        [coin1 + '-' + coin2]: chartData2
                    };

                    loadChart2();
                }).always(() => {
                    $('.correlation-loader').removeClass('open');
                    $('.correlation-chart2-block').addClass('open');
                });
            }
        };

        const loadChart1 = function () {
            if (chart1) {
                chart1.data = chartData1;
                chart1.update();
                return;
            }

            const ctx = document.getElementById('correlation-chart1').getContext('2d');
            chart1 = new Chart(ctx, {
                    type: 'line',
                    data: chartData1,
                    options: {
                        responsive: true,
                        plugins: {
                            legend: {
                                display: false,
                            },
                            title: {
                                display: false,
                            },
                            tooltip: {
                                enabled: false, // Отключаем стандартный tooltip
                                external: function (context) {
                                    let tooltipEl = document.getElementById('chart-tooltip');
                                    if (!tooltipEl) return;

                                    const tooltip = context.tooltip;
                                    if (!tooltip || tooltip.opacity === 0) {
                                        tooltipEl.style.opacity = 0;
                                        return;
                                    }

                                    // Размещаем tooltip рядом с курсором
                                    tooltipEl.style.opacity = 1;
                                    tooltipEl.style.position = 'absolute';
                                    tooltipEl.style.left = `${tooltip.caretX}px`;
                                    tooltipEl.style.top = `${tooltip.caretY - 50}px`;
                                    tooltipEl.style.pointerEvents = 'none'; // Чтобы не мешал взаимодействию

                                    tooltipEl.querySelector('.chart-tooltip-date').innerHTML = tooltip.dataPoints[0].raw.tooltipDate;
                                    tooltipEl.querySelector('.chart-tooltip-currencies').innerHTML = tooltip.dataPoints[0].dataset.label + ` <span>${tooltip.dataPoints[0].raw.y}</span>`;
                                }
                            }
                        },
                        scales: {
                            x: {
                                ticks: {
                                    color: '#76808FCC',
                                    font: {
                                        size: 12,
                                    }
                                }
                            },
                            y: {
                                min: -1, // Минимальное значение оси Y
                                max: 1,  // Максимальное значение оси Y
                                ticks: {
                                    stepSize: 0.2,
                                    color: '#76808FCC',
                                    font: {
                                        size: 14,
                                    }
                                }
                            }
                        },
                    },
                }
            );
        }

        const loadChart2 = function () {
            if (chart2) {
                chart2.data = chartData2;
                chart2.options.scales.x1.title.text = correlationCoins[pair[0]];
                chart2.options.scales.y1.title.text = correlationCoins[pair[1]];
                chart2.update();
                return;
            }


            const ctx2 = document.getElementById('correlation-chart2').getContext('2d');
            chart2 = new Chart(ctx2, {
                    type: 'line',
                    data: chartData2,
                    options: {
                        responsive: true,
                        plugins: {
                            legend: {
                                display: false,
                            },
                            title: {
                                display: false,
                            },
                            tooltip: {
                                enabled: false, // Отключаем стандартный tooltip
                                external: function (context) {

                                    let tooltipEl = document.getElementById('chart-tooltip2');
                                    if (!tooltipEl) return;

                                    const tooltip = context.tooltip;
                                    if (!tooltip || tooltip.opacity === 0) {
                                        tooltipEl.style.opacity = 0;
                                        return;
                                    }

                                    // Размещаем tooltip рядом с курсором
                                    tooltipEl.style.opacity = 1;
                                    tooltipEl.style.position = 'absolute';
                                    tooltipEl.style.left = `${tooltip.caretX}px`;
                                    tooltipEl.style.top = `${tooltip.caretY - 50}px`;
                                    tooltipEl.style.pointerEvents = 'none'; // Чтобы не мешал взаимодействию

                                    tooltipEl.querySelector('.chart-tooltip-currencies-1').innerHTML = correlationCoins[pair[0]] + ` <span>${formatSmallNumber(tooltip.dataPoints[0].datasetIndex === 0 ? tooltip.dataPoints[0].raw.x : tooltip.dataPoints[0].raw.coin1)} $</span>`;
                                    tooltipEl.querySelector('.chart-tooltip-currencies-2').innerHTML = correlationCoins[pair[1]] + ` <span>${formatSmallNumber(tooltip.dataPoints[0].datasetIndex === 0 ? tooltip.dataPoints[0].raw.y : tooltip.dataPoints[0].raw.coin2)} $</span>`;
                                }
                            }
                        },
                        scales: {
                            x1: {
                                type: 'linear',
                                display: true,
                                ticks: {
                                    color: '#76808FCC',
                                    font: {
                                        size: 12,
                                    },
                                    callback: function (value) {
                                        return formatSmallNumber(value);
                                    }
                                },
                                title: {
                                    display: true,
                                    text: correlationCoins[pair[0]],
                                    font: {
                                        size: 14,
                                    },
                                    padding: 10,// Поворот текста
                                },
                            },
                            y1: {
                                display: true,
                                ticks: {
                                    color: '#76808FCC',
                                    font: {
                                        size: 12,
                                    },
                                    callback: function (value) {
                                        return formatSmallNumber(value);
                                    }
                                },
                                title: {
                                    display: true,
                                    text: correlationCoins[pair[1]],
                                    font: {
                                        size: 14,
                                    },
                                    padding: 10,
                                },
                            },
                            x2: {
                                type: 'linear',
                                display: false,
                            },
                            y2: {
                                display: false,
                                grid: {
                                    drawOnChartArea: false // Убираем сетку с этой оси
                                }
                            }
                        },

                    },
                }
            );

        }

        // Events
        $('[data-period]').click(function (e) {
            e.preventDefault();
            const period = $(this).attr('data-period');
            currentPeriod = period;

            $('[data-period]').removeClass('correlation-tabs-item-active');
            $('[data-period="' + period + '"]').addClass('correlation-tabs-item-active');

            if (matrix[period]) {
                fillMatrix()
            }

            fetchChart1(currentPeriod, ...pair);
            fetchChart2(currentPeriod, ...pair);
        })

        $('[data-coin1][data-coin2]').click(function (e) {
            e.preventDefault();
            const coin1 = $(this).attr('data-coin1');
            const coin2 = $(this).attr('data-coin2');

            if (coin1 === coin2) return;

            pair = [coin1, coin2];

            $('.correlation-table-cell-active').removeClass('correlation-table-cell-active');
            $(e.target).addClass('correlation-table-cell-active');

            $('[data-coin1-title]').text(correlationCoins[pair[0]]);
            $('[data-coin2-title]').text(correlationCoins[pair[1]]);


            fetchChart1(currentPeriod, ...pair);
            fetchChart2(currentPeriod, ...pair);
        });

        // Init
        fetchMatrix('1M');
        fetchMatrix('3M');
        fetchMatrix('1Y');
        fetchChart1('1M', ...pair);
        fetchChart2('1M', ...pair);
        $('[data-coin1="' + pair[0] + '"][data-coin2="' + pair[1] + '"]').addClass('correlation-table-cell-active');
        $('[data-coin1-title]').text(correlationCoins[pair[0]]);
        $('[data-coin2-title]').text(correlationCoins[pair[1]]);
    });
}(jQuery));